import React from 'react'

/**
 * Parse bold markup into React <strong> elements.
 * Handles both **markdown** bold and <strong>HTML</strong> tags.
 * Safe alternative to dangerouslySetInnerHTML.
 */
export function parseInlineBold(
  text: string,
  strongStyle?: React.CSSProperties,
): React.ReactNode[] {
  // Normalize <strong>...</strong> HTML tags to **...** markdown first
  const normalized = text.replace(/<strong>(.*?)<\/strong>/gi, '**$1**')
  const parts = normalized.split(/(\*\*.+?\*\*)/g)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={i} style={strongStyle}>
          {part.slice(2, -2)}
        </strong>
      )
    }
    return part
  })
}

export interface InlineBoldProps {
  children: string
  strongStyle?: React.CSSProperties
}

/** Renders text with **bold** markdown as <strong> elements. */
export function InlineBold({ children, strongStyle }: InlineBoldProps) {
  return <>{parseInlineBold(children, strongStyle)}</>
}
